@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.filter-type-selector,
.filter-operator-selector,
.toggler {
  width: 100%;
  font-size: 14px;
}

.dropdown-toggler {
  width: 100%;
  background-color: @filter-editor--dropdown--background-color;
  height: 32px;
  border-radius: 4px;
  border: 1px solid @filter-editor--dropdown--border-color;
  &:active,
  &:hover {
    background-color: @filter-editor--dropdown--hover--background-color;
    border-top: 1px solid @filter-editor--dropdown--hover--border-color;
  }
}

.input {
  input {
    border: 1px solid @filter-editor--input--border-color;
  }
}

.menu {
  width: 100%;
}

.dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  > div {
    margin-right: 10px;
  }
}

.edit-date-picker {
  height: 32px;
  input,
  button {
    height: 32px;
  }
  input {
    border: 1px solid @filter-editor--date-input--border-color;
  }
}

.add-criteria {
  margin: 5px 0;
}

.editor-list-wrapper {
  padding-top: @space-8;
}

.create-icon {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}
